<template>
  <v-navigation-drawer
    v-model="miscAddCardDrawer"
    clipped
    temporary
    right
    app
    width="800"
    class="add-card"
    overlay-color="var(--ds-color-reverse)"
  >
    <ConfigCharts />
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { MUTATE } from '@/store/modules/mutation_types';
import cardsModel from '@/mixins/cards-model';
import ConfigCharts from '@/components/config/ConfigCharts';
import { trackEventWithUserProperties } from '@/utils/mixpanel';

export default {
  name: 'AddCard',
  components: {
    ConfigCharts,
  },
  mixins: [
    cardsModel,
  ],
  computed: {
    ...mapState('misc', [
      'addCardDrawer',
    ]),
    miscAddCardDrawer: {
      get() {
        return this.addCardDrawer;
      },
      set(newValue) {
        this.mutateMisc({
          property: 'addCardDrawer',
          with: newValue,
        });

        trackEventWithUserProperties('ST Dashboard CardGallery Open', { Opened: this.addCardDrawer });
      },
    },
  },
  methods: {
    ...mapMutations('misc', {
      mutateMisc: MUTATE,
    }),
  },
};
</script>

<style scoped lang="scss">
  .add-card {
    z-index: 12;
  }
</style>
